import React, { Suspense } from 'react';
import { Route, Routes, Router as RouterNiskopoziomowy, useLocation } from 'react-router-dom';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import userActions from "./redux/user/actions";
import { connect } from 'react-redux';

// import routers config
import {
    ROUTE_DASHBOARD,
    ROUTE_REGISTER,
    ROUTE_LOGIN,
    ROUTE_FORGOT_PASSWORD,
    ROUTE_RESET_PASSWORD,
    // ROUTE_USERS_LIST,
    ROUTE_WORKSPACES_LIST,
    ROUTE_PROFILE_EDIT,
    ROUTE_ACTIVE_WORKSPACES_DETAILS,
    ROUTE_WORKSPACE_DETAIL,
    ROUTE_CONTACT_TYPE_LIST,
    ROUTE_ADDRESS_TYPE_LIST,
    ROUTE_ADDRESS_TYPE_CREATE,
    ROUTE_COUNTRY_LIST,
    ROUTE_CONSENTS,
    ROUTE_CONSENT_CREATE,
    ROUTE_CONSENT_EDIT,
    ROUTE_EMPLOYEE_DOCUMENT_TYPE_CREATE,
    ROUTE_EMPLOYEE_DOCUMENT_TYPE_LIST,
    ROUTE_ROUTES,
    ROUTE_DEVICES,
    ROUTE_DEVICES_DETAILS,
    ROUTE_DRIVERS,
    ROUTE_DRIVERS_DETAILS,
    ROUTE_VEHICLES,
    ROUTE_VEHICLES_DETAILS,
    ROUTE_TELEMETRY,
    ROUTE_ROUTE_REPORT,
    ROUTE_POI,
    ROUTE_STATISTICS,
    ROUTE_WORKSPACE_CREATE,
    ROUTE_WORKSPACE_BLOCKED,
    ROUTE_ECODRIVING,
    ROUTE_INVOICES,
    ROUTE_INVOICES_DETAILS,
    ROUTE_INVOICE,
    ROUTE_TARIFF_LIST,
    ROUTE_TARIFF_LOGS,
    ROUTE_PAYMENT_LOGS,
    ROUTE_INVOICE_AFTER_PAY,
    ROUTE_SENT
} from "./config/routes";

// import layout
import Layout from "./layouts";
import Loader from "./components/layout/Loader/Loader";
import NotFoundPage from './pages/system/404';
import GranicaBledu from './components/granicaBledu';

// import types
import { RouterTypeProps } from "./router.type";
import {ReducerType} from "./redux/reducer.type";
import {getSessionSuperAdminWorkspace} from "./utils/utils";

/**
 * Leniwe ladowanie ekranu.
 *
 * Wczesniej robil to `react-loadable` - pakiet BEZ UTRZYMANIA, ktorego
 * ostatnie wydanie pochodzi z 2018 roku. `React.lazy` jest wbudowane
 * w Reacta i robi dokladnie to samo, a ten projekt uzywa go JUZ
 * w 24 innych plikach - wzorzec nie jest nowy, tylko dokonczony.
 *
 * Wskaznik ladowania przeniosl sie z opcji `loading` do `Suspense`
 * przy kazdej trasie (nizej), zeby stal WEWNATRZ granicy bledu:
 * nieudane pobranie fragmentu trafia wtedy do granicy tego ekranu,
 * a nie wywraca calej aplikacji.
 */
const loadable = (loader: () => Promise<{ default: React.ComponentType<any> }>) =>
    React.lazy(loader);

const routes = [
    {
        path: ROUTE_DASHBOARD,
        Component: loadable(() => import('./pages/dashboard')),
    },
    {
        path: ROUTE_REGISTER(),
        Component: loadable(() => import('./pages/system/register')),
    },
    {
        path: ROUTE_LOGIN,
        Component: loadable(() => import('./pages/system/login')),
    },
    {
        path: ROUTE_FORGOT_PASSWORD,
        Component: loadable(() => import('./pages/system/forgot-password')),
    },
    {
        path: ROUTE_RESET_PASSWORD,
        Component: loadable(() => import('./pages/system/reset-password')),
    },
    // {
    //     path: ROUTE_USERS_LIST,
    //     Component: loadable(() => import('./pages/users_workspaces/users_list')),
    //     exact: true,
    // },
    {
        path: ROUTE_WORKSPACES_LIST,
        Component: loadable(() => import('./pages/users_workspaces/workspaces_list')),
    },
    {
        path: ROUTE_PROFILE_EDIT,
        Component: loadable(() => import('./pages/users_workspaces/profile_edit')),
    },
    {
        path: ROUTE_ACTIVE_WORKSPACES_DETAILS,
        Component: loadable(() => import('./pages/workspace_details')),
        // Component: loadable(() => import('./pages/users_workspaces/workspace_details')),
    },
    {
        path: ROUTE_WORKSPACE_DETAIL(),
        Component: loadable( () => import('./pages/workspace_details'))
    },
    {
        path: ROUTE_CONTACT_TYPE_LIST,
        Component: loadable( () => import('./pages/dictionaries/contact_type/list'))
    },
    {
        path: ROUTE_ADDRESS_TYPE_LIST,
        Component: loadable( () => import('./pages/dictionaries/address_types/show_address_types'))
    },
    {
        path: ROUTE_ADDRESS_TYPE_CREATE,
        Component: loadable( () => import('./pages/dictionaries/address_types/create_address_type'))
    },
    {
        path: ROUTE_COUNTRY_LIST,
        Component: loadable(() => import("./pages/dictionaries/countries/show_countries"))
    },
    {
        path: ROUTE_CONSENTS,
        Component: loadable(() => import('./pages/dictionaries/consent_types')),
    },
    {
        path: ROUTE_CONSENT_CREATE,
        Component: loadable(() => import('./pages/dictionaries/consent_types/create')),
    },
    {
        path: ROUTE_CONSENT_EDIT(),
        Component: loadable(() => import('./pages/dictionaries/consent_types/edit')),
    },
    {
        path: ROUTE_EMPLOYEE_DOCUMENT_TYPE_CREATE,
        Component: loadable(() => import('./pages/dictionaries/employee-document-type/create/employee-document-type-create')),
    },
    {
        path: ROUTE_EMPLOYEE_DOCUMENT_TYPE_LIST,
        Component: loadable(() => import('./pages/dictionaries/employee-document-type/list/employee-document-type-list')),
    },
    {
        path: ROUTE_ROUTES,
        Component: loadable(() => import("./pages/routes"))
    },
    {
        path: ROUTE_DEVICES,
        Component: loadable(() => import("./pages/devices"))
    },
    {
        path: ROUTE_DEVICES_DETAILS(),
        Component: loadable(() => import("./pages/devices/details"))
    },
    // {
    //     path: ROUTE_CUSTOMERS,
    //     Component: loadable(() => import("./pages/customer")),
    //     exact: true
    // },
    // {
    //     path: ROUTE_CUSTOMERS_DETAILS(),
    //     Component: loadable(() => import("./pages/customer/details")),
    //     exact: true
    // },
    {
        path: ROUTE_DRIVERS,
        Component: loadable(() => import("./pages/drivers"))
    },
    {
        path: ROUTE_DRIVERS_DETAILS(),
        Component: loadable(() => import("./pages/drivers/details"))
    },
    {
        path: ROUTE_VEHICLES,
        Component: loadable(() => import("./pages/vehicles"))
    },
    {
        path: ROUTE_VEHICLES_DETAILS(),
        Component: loadable(() => import("./pages/vehicles/details"))
    },
    {
        path: ROUTE_TELEMETRY,
        Component: loadable(() => import("./pages/telemetry"))
    },
    {
        path: ROUTE_ROUTE_REPORT,
        Component: loadable(() => import("./pages/route-report"))
    },
    {
        path: ROUTE_POI,
        Component: loadable(() => import("./pages/user_poi"))
    },
    {
        path: ROUTE_SENT,
        Component: loadable(() => import("./pages/sent"))
    },
    {
        path: ROUTE_STATISTICS,
        Component: loadable(() => import("./pages/statistics"))
    },
    {
        path: ROUTE_WORKSPACE_CREATE,
        Component: loadable(() => import("./pages/users_workspaces/workspace_create"))
    },
    {
        path: ROUTE_WORKSPACE_BLOCKED,
        Component: loadable(() => import("./pages/system/blocked"))
    },
    {
        path: ROUTE_ECODRIVING,
        Component: loadable(() => import("./pages/ecodriving"))
    },
    {
        path: ROUTE_INVOICES(),
        Component: loadable(() => import("./pages/invoices"))
    },
    {
        path: ROUTE_INVOICE,
        Component: loadable(() => import("./pages/invoices"))
    },
    {
        path: ROUTE_INVOICE_AFTER_PAY(),
        Component: loadable(() => import("./pages/invoices/afterPay"))
    },
    {
        path: ROUTE_INVOICES_DETAILS(),
        Component: loadable(() => import("./pages/invoices/details"))
    },
    {
        path: ROUTE_TARIFF_LIST,
        Component: loadable(() => import("./pages/tariff/list"))
    },
    {
        path: ROUTE_TARIFF_LOGS,
        Component: loadable(() => import("./pages/tariff/logs"))
    },
    {
        path: ROUTE_PAYMENT_LOGS,
        Component: loadable(() => import("./pages/payment"))
    },

];

/**
 * Spiecie NASZEGO wspolnego obiektu `history` z routerem 6.
 *
 * Szostka nie pozwala podac wlasnej historii do `<BrowserRouter>` — tworzy
 * swoja. A ta aplikacja ma jeden wspolny obiekt w `src/config/historia.ts`
 * i wola na nim `push` 52 razy, `replace` 6 razy, a takze `listen`
 * i `location.search` — w tym Z SAG, czyli spoza Reacta. Gdyby router mial
 * wlasna historie, te 60 wywolan przestaloby cokolwiek robic PO CICHU.
 *
 * Uzywam niskopoziomowego `<Router location navigator>`, ktory jest
 * STABILNYM i udokumentowanym elementem API szostki. CELOWO NIE
 * `unstable_HistoryRouter` — react-router sam oznacza go jako niestabilny
 * i zapowiada mozliwe usuniecie.
 *
 * `history.listen` w wersji 5 podaje `{ action, location }` — czyli
 * dokladnie ksztalt tego stanu, stad `ustawStan` wprost jako funkcja zwrotna.
 */
function RouterHistorii({ history, children }: { history: any; children: React.ReactNode }) {
    const [stan, ustawStan] = React.useState({ action: history.action, location: history.location });

    /*
     * `useLayoutEffect`, a nie `useEffect`: nasluch musi byc podpiety ZANIM
     * przegladarka cokolwiek narysuje.
     *
     * NADROBIENIE ZALEGLOSCI NA POCZATKU — BEZ NIEGO APLIKACJA NIE WSTAJE.
     *
     * React wykonuje efekty OD DZIECI DO RODZICOW. `componentDidMount`
     * ukladu strony jest wiec wczesniej niz ten efekt, a to wlasnie tam
     * siedzi przekierowanie wylogowanego uzytkownika na logowanie
     * (`layouts/index.tsx`: `pathname === '/' && !access_token`).
     *
     * Kolejnosc bez tej poprawki:
     *   1. pierwszy render — adres `/`, zaden ekran nie pasuje, leci 404,
     *   2. `componentDidMount` ukladu wola `history.push('/auth/login')`,
     *   3. DOPIERO TERAZ podpinamy nasluch — przepchniecie juz przepadlo.
     *
     * Objaw byl mylacy: pasek adresu pokazywal `/auth/login`, a na ekranie
     * stala strona 404. Zadnego bledu w konsoli, bo nic sie nie zepsulo —
     * router po prostu nie dowiedzial sie o zmianie.
     *
     * Porownanie `location` wystarczy: `history` oddaje przy kazdej zmianie
     * NOWY obiekt, wiec rownosc referencji znaczy "nic sie nie stalo"
     * i nie wywoluje zbednego odswiezenia.
     */
    React.useLayoutEffect(() => {
        // Stan USTAWIANY W EFEKCIE jest tu caloscia poprawki — to wlasnie
        // nadrobienie przekierowania, ktore zdarzylo sie wczesniej (opis wyzej).
        // Warunek w srodku pilnuje, zeby przy braku zmiany nic sie nie dzialo.
        // eslint-disable-next-line react-hooks/set-state-in-effect
        ustawStan((poprzedni) =>
            poprzedni.location === history.location
                ? poprzedni
                : { action: history.action, location: history.location },
        );
        return history.listen(ustawStan);
    }, [history]);

    return (
        <RouterNiskopoziomowy
            location={stan.location}
            navigationType={stan.action}
            navigator={history}
        >
            {children}
        </RouterNiskopoziomowy>
    );
}

/**
 * Animacja przejscia miedzy ekranami.
 *
 * Bylo `react-router-transition-switch` — nakladka na `<Switch>` z piatki,
 * ktora nie dziala z szostka (paczka bez wydania od siedmiu lat). Ten sam
 * efekt daje `useLocation` plus te same `SwitchTransition`/`CSSTransition`,
 * ktore juz tu byly.
 *
 * `location` jest podawana dalej CELOWO: `<Routes location={...}>` musi
 * dostac te sama, ktora animujemy, inaczej stary ekran zniknie natychmiast
 * zamiast wyjsc animacja.
 */
function PrzejsciaTras({
    animacja,
    children,
}: {
    animacja: string;
    children: (location: ReturnType<typeof useLocation>) => React.ReactElement;
}) {
    const location = useLocation();
    return (
        <SwitchTransition>
            <CSSTransition
                key={location.pathname}
                classNames={animacja}
                timeout={animacja === 'none' ? 0 : 300}
            >
                {children(location)}
            </CSSTransition>
        </SwitchTransition>
    );
}

const mapStateToProps = (state: ReducerType) =>({ is_super_admin: state.user.is_super_admin, settings: state.settings });

class Router extends React.Component<RouterTypeProps, {}> {

    componentDidMount(): void {
        if (sessionStorage.getItem("superAdminWorkspace")){
            this.props.dispatch({
                type: userActions.CHANGE_ACTIVE_WORKSPACE,
                payload: getSessionSuperAdminWorkspace()
            })
        }
        // if (validateLocalStorage("access_token")){
        //     console.log(localStorage.getItem("access_token"), "local");
        //     // axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`;
        //     // @ts-ignore
        //     localStorage.setItem("access_token", sessionStorage.getItem("access_token"))
        // }
    }

    componentDidUpdate(prevProps: Readonly<RouterTypeProps>, prevState: Readonly<{}>, snapshot?: any): void {
        if((prevProps.is_super_admin !== this.props.is_super_admin) && this.props.is_super_admin){
            sessionStorage.setItem("superAdmin", `${this.props.is_super_admin}`);
            localStorage.setItem("superAdmin", `${this.props.is_super_admin}`)
        }
    }

    render(): React.ReactNode {
        const {
            history,
            settings: { routerAnimation },
        } = this.props;
        return (
            <RouterHistorii history={history}>
                <Layout>
                    <PrzejsciaTras animacja={routerAnimation}>
                        {(location) => (
                            <Routes location={location}>
                                {routes.map(({ path, Component }) => (
                                    <Route
                                        path={path}
                                        key={path}
                                        element={
                                            /*
                                             * GRANICA BLEDU WOKOL KAZDEGO EKRANU.
                                             *
                                             * Stoi WEWNATRZ `Layout`, wiec blad w jednym ekranie
                                             * nie zabiera naglowka ani menu — uzytkownik moze
                                             * przejsc gdzie indziej zamiast patrzec na biala
                                             * strone. Wczesniej projekt nie mial zadnej granicy:
                                             * pierwszy wyjatek w `render` odmontowywal cale
                                             * drzewo i zostawal pusty `#root`.
                                             *
                                             * `key={path}` na `Route` sprawia, ze przy zmianie
                                             * ekranu granica montuje sie od nowa, czyli zapamietany
                                             * blad nie przenosi sie miedzy ekranami.
                                             */
                                            // @ts-ignore
                                            <GranicaBledu sciezka={path}>
                                                <Suspense fallback={<Loader fullScreen spinning/>}>
                                                    <Component admin={this.props.is_super_admin} />
                                                </Suspense>
                                            </GranicaBledu>
                                        }
                                    />
                                ))}
                                {/*
                                  * TRASA ZAPASOWA. W piatce bylo `<Route component={X}/>`
                                  * bez `path` — szostka wymaga jawnego `path="*"`.
                                  */}
                                <Route path="*" element={<NotFoundPage />} />
                            </Routes>
                        )}
                    </PrzejsciaTras>
                </Layout>
            </RouterHistorii>
        );
    }
}

export default connect(mapStateToProps)(Router);
